export const getUsername = user => {
  return user.uniqueDisplayName || 'DM_User_' + user.objectId.slice(-2)
}
